import script from "./CallFailedDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallFailedDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__